import ArticleLayout from '@/pages/articles/components/ArticleLayout';

export default function KakobuyVsYoybuy() {
  return <ArticleLayout slug="kakobuy-vs-yoybuy" />;
}